import React, { useMemo } from 'react';
import Table from 'src/components/Table';
import Skeleton from 'src/components/Skeleton/Skeleton';
import { createSuitesTableColumns } from 'src/components/SuitesTable/helpers';
import './SuitesTableView.scss';
import { useTablePagination } from 'src/SharedCustomHooks/UseTablePagination/useTablePagination';

const SKELETON_ROW_COUNT: number = 13;

const SuitesTableView = ({
  filteredSuites,
  onSuiteClick,
  onToggleMobileSync,
  loading = false,
  persistKey,
}: any) => {
  const { itemsPerPage, onItemsPerPageChange } = useTablePagination();

  const columns: any[] = useMemo(
    () => createSuitesTableColumns(onSuiteClick, onToggleMobileSync),
    [onSuiteClick, onToggleMobileSync]
  );

  const skeletonColumns: any[] = useMemo(
    () =>
      columns.map((column: any) => ({
        ...column,
        cell: () => <Skeleton variant="text" width="70%" />,
      })),
    [columns]
  );

  const skeletonData: any[] = useMemo(
    () =>
      Array.from({ length: SKELETON_ROW_COUNT }, (_, index: number) => ({
        id: `suites-skeleton-${index}`,
      })),
    []
  );

  return (
    <div className="table-scroller">
      <div className="suites-table-scroll-wrapper">
        <Table
          defaultSort={{
            accessor: 'number',
            direction: 'descending',
          }}
          columns={loading ? skeletonColumns : columns}
          data={loading ? skeletonData : filteredSuites}
          headerTop={undefined}
          paginate={{
            itemsPerPage,
            position: 'both',
            persistKey,
          }}
          paginationSkeleton={loading}
          onItemsPerPageChange={onItemsPerPageChange}
        />
      </div>
    </div>
  );
};

export default SuitesTableView;
